// Avatar utility functions for mapping favorite animals to profile images

// Import all available avatar images
import bearImage from '../assets/images/avatars/Bear.png';
import butterflyImage from '../assets/images/avatars/Butterfly.png';
import catImage from '../assets/images/avatars/Cat.png';
import dogImage from '../assets/images/avatars/Dog.png';
import dolphinImage from '../assets/images/avatars/Dolphin.png';
import eagleImage from '../assets/images/avatars/Eagle.png';
import elephantImage from '../assets/images/avatars/Elephant.png';
import flamingoImage from '../assets/images/avatars/Flamingo.png';
import foxImage from '../assets/images/avatars/Fox.png';
import guineaPigImage from '../assets/images/avatars/Guinea Pig.png';
import hamsterImage from '../assets/images/avatars/Hamster.png';
import horseImage from '../assets/images/avatars/Horse.png';
import kangarooImage from '../assets/images/avatars/Kangaroo.png';
import kittenImage from '../assets/images/avatars/Kitten.png';
import koalaImage from '../assets/images/avatars/Koala.png';
import lionImage from '../assets/images/avatars/Lion.png';
import monkeyImage from '../assets/images/avatars/Monkey.png';
import orangutanImage from '../assets/images/avatars/Orangutan.png';
import otterImage from '../assets/images/avatars/Otter.png';
import pandaImage from '../assets/images/avatars/Panda.png';
import parrotImage from '../assets/images/avatars/Parrot.png';
import peacockImage from '../assets/images/avatars/Peacock.png';
import penguinImage from '../assets/images/avatars/Penguin.png';
import puppyImage from '../assets/images/avatars/Puppy.png';
import rabbitImage from '../assets/images/avatars/Rabbit.png';
import seaOtterImage from '../assets/images/avatars/Sea Otter.png';
import sharkImage from '../assets/images/avatars/Shark.png';
import turtleImage from '../assets/images/avatars/Turtle.png';
import tigerImage from '../assets/images/avatars/Tiger.png';
import wallabeeImage from '../assets/images/avatars/Wallabee.png';
import wolfImage from '../assets/images/avatars/Wolf.png';

// Map favorite animals to their corresponding avatar images
export const animalAvatarMap = {
  // Dogs
  'dog': dogImage,
  'dogs': dogImage,
  'puppy': puppyImage,
  'puppies': puppyImage,
  
  // Cats
  'cat': catImage,
  'cats': catImage,
  'kitten': kittenImage,
  'kittens': kittenImage,
  
  // Pandas
  'panda': pandaImage,
  'pandas': pandaImage,
  
  // Birds & insects
  'eagle': eagleImage,
  'eagles': eagleImage,
  'flamingo': flamingoImage,
  'flamingos': flamingoImage,
  'penguin': penguinImage,
  'penguins': penguinImage,
  'parrot': parrotImage,
  'parrots': parrotImage,
  'peacock': peacockImage,
  'peacocks': peacockImage,
  'butterfly': butterflyImage,
  'butterflies': butterflyImage,

  // Marine animals
  'dolphin': dolphinImage,
  'dolphins': dolphinImage,
  'otter': otterImage,
  'otters': otterImage,
  'sea otter': seaOtterImage,
  'sea otters': seaOtterImage,
  'shark': sharkImage,
  'sharks': sharkImage,
  'sea turtle': turtleImage,
  'turtle': turtleImage,
  'turtles': turtleImage,
  
  // Large mammals
  'elephant': elephantImage,
  'elephants': elephantImage,
  'horse': horseImage,
  'horses': horseImage,
  'bear': bearImage,
  'bears': bearImage,
  'lion': lionImage,
  'lions': lionImage,
  'tiger': tigerImage,
  'tigers': tigerImage,
  'wolf': wolfImage,
  'wolves': wolfImage,
  'fox': foxImage,
  'foxes': foxImage,
  
  // Other animals
  'rabbit': rabbitImage,
  'rabbits': rabbitImage,
  'wallabee': wallabeeImage,
  'wallaby': wallabeeImage,
  'wallabies': wallabeeImage,
  'kangaroo': kangarooImage,
  'kangaroos': kangarooImage,
  'koala': koalaImage,
  'koalas': koalaImage,
  'monkey': monkeyImage,
  'monkeys': monkeyImage,
  'orangutan': orangutanImage,
  'orangutans': orangutanImage,
  'guinea pig': guineaPigImage,
  'guinea pigs': guineaPigImage,
  'hamster': hamsterImage,
  'hamsters': hamsterImage,

  // Default fallback
  'default': dogImage
};

// Function to get avatar image based on favorite animal
export const getAvatarImage = (favoriteAnimal) => {
  if (!favoriteAnimal) {
    return animalAvatarMap.default;
  }
  
  const normalizedAnimal = favoriteAnimal.toLowerCase().trim();
  return animalAvatarMap[normalizedAnimal] || animalAvatarMap.default;
};

// Function to get user profile data from localStorage
export const getUserProfileData = () => {
  try {
    // Try to get from student profile data first
    const studentData = localStorage.getItem('studentProfileData');
    if (studentData) {
      const parsed = JSON.parse(studentData);
      return {
        favoriteAnimal: parsed.favoriteAnimal || '',
        username: parsed.username || '',
        displayUsername: parsed.displayUsername || '',
        name: parsed.name || '',
        grade: parsed.grade || '',
        schoolName: parsed.schoolName || ''
      };
    }
    
    // Fallback to individual localStorage items
    return {
      favoriteAnimal: localStorage.getItem('favoriteAnimal') || '',
      username: localStorage.getItem('signupUsername') || '',
      displayUsername: '',
      name: localStorage.getItem('signupName') || '',
      grade: localStorage.getItem('currentGrade') || '',
      schoolName: localStorage.getItem('schoolName') || ''
    };
  } catch (error) {
    console.error('Error getting user profile data:', error);
    return {
      favoriteAnimal: '',
      username: '',
      displayUsername: '',
      name: '',
      grade: '',
      schoolName: ''
    };
  }
};
